export default __webpack_public_path__ + "8c6e8b3ee5375b925bac6e10da8e3f26.png";